// Disable Copy Protection Script
// Prevents right-click context menu
window.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});

// Prevent text selection
document.addEventListener("selectstart", (e) => {
  e.preventDefault();
});

// Prevent image dragging
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('dragstart', function(e) {
      e.preventDefault();
    });
  });
});

// Helper function for Ctrl+Shift key combinations
function ctrlShiftKey(e, keyCode) {
  return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
}

// Disable developer tools shortcuts
document.addEventListener('keydown', function(e) {
  if (
    e.keyCode === 123 || // F12
    ctrlShiftKey(e, 'I') || // Ctrl+Shift+I (Inspector)
    ctrlShiftKey(e, 'J') || // Ctrl+Shift+J (Console)
    ctrlShiftKey(e, 'C') || // Ctrl+Shift+C (Element selector)
    (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) // Ctrl+U (View source)
  ) {
    e.preventDefault();
  }
});

// Additional protection functions

// Block extensions and inspect tools
(function() {
  'use strict';
  
  // Disable console
  const devtools = {
    open: false,
    orientation: null
  };
  
  setInterval(function() {
    if (window.outerHeight - window.innerHeight > 200 || window.outerWidth - window.innerWidth > 200) {
      if (!devtools.open) {
        devtools.open = true;
        console.clear();
        console.log('%cDeveloper tools detected!', 'color: red; font-size: 20px; font-weight: bold;');
      }
    } else {
      devtools.open = false;
    }
  }, 500);
  
  // Override console methods
  const noop = () => {};
  const methods = ['log', 'debug', 'info', 'warn', 'error', 'table', 'trace', 'dir', 'dirxml', 'group', 'groupCollapsed', 'groupEnd', 'clear', 'count', 'countReset', 'time', 'timeLog', 'timeEnd', 'profile', 'profileEnd', 'timeStamp'];
  
  methods.forEach(method => {
    console[method] = noop;
  });
})();

// Disable shortcuts for copy, cut, paste
document.addEventListener('keydown', function(e) {
  // Disable Ctrl+A (Select All)
  if (e.ctrlKey && e.keyCode === 65) {
    e.preventDefault();
  }
  // Disable Ctrl+C (Copy)
  if (e.ctrlKey && e.keyCode === 67) {
    e.preventDefault();
  }
  // Disable Ctrl+V (Paste)
  if (e.ctrlKey && e.keyCode === 86) {
    e.preventDefault();
  }
  // Disable Ctrl+X (Cut)
  if (e.ctrlKey && e.keyCode === 88) {
    e.preventDefault();
  }
  // Disable Ctrl+S (Save)
  if (e.ctrlKey && e.keyCode === 83) {
    e.preventDefault();
  }
  // Disable Ctrl+P (Print)
  if (e.ctrlKey && e.keyCode === 80) {
    e.preventDefault();
  }
});